import React, { useEffect, useState } from "react";
import NotificationAside from "./NotificationAside";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import NotificationList from "./NotificationList";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { updateMenuData } from "../../store/slices/misc/menuData";
import TopMenu from "../../route/topMenu";
import { RootState } from "../../store/store";

const NotificationMain = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { data: menuData } = useSelector((state: RootState) => state.menu);

  const [counts, setCounts] = useState({ fyiCount: 0, fyaCount: 0 });
  const [aside, setAside] = useState(false);
  const [currentTab, setCurrentTab] = useState("For Your Information"); // Manage currentTab here
  useEffect(() => {
    resizeFunc();
    window.addEventListener("resize", resizeFunc);
    return () => {
      window.removeEventListener("resize", resizeFunc);
    };
  }, []);

  const resizeFunc = () => {
    setAside(false);
  };

  useEffect(() => {
    // Check if we're in a project context
    // Priority: location.state > menuData.linkState > pathname check
    const projectIdFromState = location.state?.id || location.state?.projectId;

    // Check existing menuData for project context (set by project pages)
    // Only check menuData when location changes, not when menuData changes (to avoid infinite loop)
    const existingMenuData: any[] = menuData || [];
    const firstMenuItem: any = existingMenuData[0];
    const projectIdFromMenu =
      firstMenuItem?.linkState?.id || firstMenuItem?.linkState?.projectId;

    const isProjectPath = location.pathname?.includes("/pms/project/");

    // Determine if we're in project context
    const isProjectContext =
      !!projectIdFromState || !!projectIdFromMenu || isProjectPath;

    const menuToUse = isProjectContext
      ? TopMenu?.projectNav
      : TopMenu?.activeProjects;

    // Use location.state if available, otherwise use menuData's linkState
    const linkState = location.state || firstMenuItem?.linkState || {};

    dispatch(
      updateMenuData(
        menuToUse?.map((item: any) => {
          return {
            ...item,
            linkState: linkState,
          };
        })
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, location.state, dispatch]);

  return (
    <React.Fragment>
      <Head title="Inbox"></Head>
      <Content>
        <div className="nk-ibx">
          <NotificationAside
            aside={aside}
            setAside={setAside}
            currentTab={currentTab} // Pass currentTab to NotificationAside
            setCurrentTab={setCurrentTab} // Pass the setter function
            counts={counts}
          />
          {aside && (
            <div
              className="toggle-overlay"
              onClick={() => setAside(!aside)}
            ></div>
          )}
          <NotificationList currentTab={currentTab} setCounts={setCounts} />
        </div>
      </Content>
    </React.Fragment>
  );
};

export default NotificationMain;
